import $ from 'jquery';

var popupLink = $('.js-show-popup');
var closePopup = $('.js-close-popup');

showPopup();
hidePopup();

function showPopup() {
    popupLink.click((e) => {
        e.preventDefault();

        let elem = e.target,
            popupId = $(elem).data('popup-id');

        $('#' + popupId).addClass('is-visible');
    });
}


function hidePopup() {
    closePopup.click((e) => $(e.target).closest('.js-popup').removeClass('is-visible'));
}